import { useTranslation } from 'react-i18next';
import * as vp from 'vopay';

type UpdateGlobalPaymentsRows = {
  label: vp.UpdateGlobalPaymentsLabel;
  id: vp.UpdateGlobalPaymentsId;
  preset: keyof vp.TextFieldPresets | undefined;
  required: boolean;
};

const useBuildUpdateGlobalPaymentsRows = (): UpdateGlobalPaymentsRows[] => {
  const { t } = useTranslation('translations', { keyPrefix: 'Integrations.GlobalPayments.Form' });

  return [
    {
      label: t('globalPayAppID'),
      id: vp.UpdateGlobalPaymentsId.GlobalPayAppID,
      preset: 'text',
      required: true,
    },
    {
      label: t('globalPaySharedSecret'),
      id: vp.UpdateGlobalPaymentsId.GlobalPaySharedSecret,
      preset: 'text',
      required: true,
    },
  ];
};
export default useBuildUpdateGlobalPaymentsRows;
